import {groupBy} from 'lodash';
import * as React from 'react';

import SalesEventsDateView from './SalesEventsDateView';
import * as styles from './salesEvents.module.scss';
import GridTwoCol from '@src/components/Grid/GridTwoCol';

import type {
  SalesEvents,
  SalesEventsSales_Event_Venue as SalesEventVenue,
} from '@graphql-types';
import {format} from 'date-fns';
import {useTranslation} from 'react-i18next';
import {parseDate} from '@src/utils';

export type SalesEventsType = Pick<
  SalesEvents,
  | 'id'
  | 'name'
  | 'start_time'
  | 'duration_minutes'
  | 'zoneless_start_time_at'
  | 'sales_event_venue'
  | 'time_zone'
  | 'language'
  | 'record_locator'
>;

export type SalesEventsVenueType = Pick<
  SalesEventVenue,
  | 'id'
  | 'name'
  | 'address1'
  | 'address2'
  | 'city'
  | 'state'
  | 'zip'
  | 'county_name'
>;

interface SalesEventsAgendaViewProps {
  salesEvents: SalesEventsType[];
}

const SalesEventsAgendaView: React.FC<SalesEventsAgendaViewProps> = ({
  salesEvents,
}) => {
  const salesEventsByDate = groupBy(
    salesEvents,
    salesEvent => salesEvent.zoneless_start_time_at.split(' ')[0],
  );
  const sortedDates = Object.keys(salesEventsByDate).sort();
  const {t} = useTranslation('SalesEvents');

  const formattedEventDate = (date: string) => {
    const events = salesEventsByDate[date];
    const eventStartTime = parseDate(events[0].zoneless_start_time_at);
    return `${format(eventStartTime, 'MMMM dd, yyyy')} \n (${format(
      eventStartTime,
      'EEEE',
    )})`;
  };
  return sortedDates.length === 0 ? (
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <p>
          <strong>{t('salesEventsNotFoundMessage')}</strong>
        </p>
      </div>
    </div>
  ) : (
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <p>
          <strong>{t('giftCardPromotionMessage')}</strong>
        </p>
      </div>
      <GridTwoCol border="gray" gridType="wide">
        {sortedDates.map((date, index) => (
          <div className="row" key={index}>
            <div className={styles.eventDate + ' left'}>
              <h3>{formattedEventDate(date)}</h3>
            </div>
            <div className="right">
              <SalesEventsDateView
                salesEvents={salesEventsByDate[date]}
                key={index}
              />
            </div>
          </div>
        ))}
        <div className={styles.row}>
          <p>
            <strong>{t('salesEventsFooterMessage')}</strong>
          </p>
        </div>
      </GridTwoCol>
      <div>{t('giftCardPromotionDisclaimer')}</div>
    </div>
  );
};

export default SalesEventsAgendaView;
